import { safeParseToInt, stringToBoolean } from "@r-and-a-shared-ui/utils";

export const RedisConfig = Object.freeze({
    REDIS_AVAILABLE: stringToBoolean(process.env["REDIS_AVAILABLE"]),
    REDIS_URL: process.env["REDIS_HOST"] ?? 'redis://localhost:6379',
    REDIS_PASSWORD: process.env["REDIS_PASSWORD"],
    REDIS_USER: process.env["REDIS_USER"],
    REDIS_PORT: safeParseToInt(process.env["REDIS_PORT"]) ?? 6379,
    REDIS_SSL: stringToBoolean(process.env["REDIS_SSL"])
});